"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var serverSideSchema = function (props) {
    var renderSchemaString = function (schemaString, i) {
        return schemaString ? (React.createElement("script", { key: i, type: "application/ld+json", dangerouslySetInnerHTML: { __html: schemaString } })) : null;
    };
    if (!props.schemaStrings)
        return null;
    return (React.createElement(React.Fragment, null, props.schemaStrings.map(renderSchemaString)));
};
exports.default = react_redux_1.connect(function (state) { return state.serverSideSchema; }, function () { return ({}); })(serverSideSchema);
